import React from 'react';

import TracPage from '@services/tracpage/types/trac-page';
import useIsMobile from '@shared-tracpage/hooks/is-mobile';
import {
  DetailNav,
  InnerContent,
  NavContent,
  StyledContainer,
  Wrapper,
} from '@shared-tracpage/components/container';
import { ArtistInfoDetail } from '@shared-tracpage/components/artist-info-detail';
import TracpageNavbar from '../navbar';
import styled from 'styled-components';
import Sidebar from '../sidebar';

type ContainerVariant = 'default' | 'detail' | 'billing' | 'error';

export default function Container({
  className,
  children,
  pageData,
  featuredItem,
  variant = 'default',
}: {
  className?: string;
  children: React.ReactNode;
  pageData: TracPage;
  analytics?: never;
  variant?: ContainerVariant;
  featuredItem?: never;
}) {
  const isMobile = useIsMobile();

  if (!pageData) {
    return null;
  }

  return (
    <StyledContainer className={className ? className : ''}>
      {variant === 'default' ? (
        <StyledSidebar
          featuredItem={featuredItem}
          pageData={pageData}
          onCartClick={() => null}
        />
      ) : null}
      <Wrapper className={`wrapper ${variant}`}>
        <>
          {!isMobile && variant === 'default' ? (
            <NavContent>
              <TracpageNavbar />
            </NavContent>
          ) : null}
          {variant === 'detail' || variant === 'error' ? (
            <DetailNav>
              <ArtistInfoDetail pageData={pageData} />
            </DetailNav>
          ) : null}
          {variant === 'billing' ? (
            <DetailNav className="billing-section">
              <ArtistInfoDetail
                className="billing-artist-info-detail"
                pageData={pageData}
              />
            </DetailNav>
          ) : null}
          <InnerContent className={`inner-content ${variant}`}>
            {children}
          </InnerContent>
        </>
      </Wrapper>
    </StyledContainer>
  );
}

const StyledSidebar = styled(Sidebar)`
  grid-column: 2 / 6;
  @media (max-width: ${({ theme }) => `${theme.breakpoints.laptop}px`}) {
    grid-column: 2 / 7;
  }
  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    grid-column: unset;
    padding-inline: 24px;
    max-height: none;
    overflow: unset;
  }
`;
